module.exports = "/packs/course-small-illustrator-bd3fc68d53d0454f8ba88d8eefb6ba38.png";